import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import SectionHeaderLayout from "../../common/components/SectionHeaderLayout";
import RedirectionHandler from "../../common/handlers/RedirectionHandler";
import RewardItem from "./subComponent/RewardItem";
import { RewardsSectionContent } from "./types";
import { componentNameConstants } from "@repo/analytics/data-layer.constants";

const RewardSection = ({ content }: { content: RewardsSectionContent }) => {
  const { list } = content;
  const objValueList = Object.values(list);

  return (
    <SectionHeaderLayout>
      <div className={`flex flex-row gap-[16px] max-md:gap-[12px] `}>
        {
          objValueList?.map((el, idx) => {
            return (<RedirectionHandler
              url={isOpenInApp() ? el.appdataurl : el.webdataurl} key={el?.cardTitle}
              cta_text={el?.cardTitle} section_title={componentNameConstants.REWARDS}
              isLoginRequired={el?.isLoginRequired ?? "false"}
            >
              <RewardItem url={isOpenInApp() ? el.mobileImage : el.desktopimage} title={el.cardTitle} />
            </RedirectionHandler>
            )
          })
        }
      </div>
    </SectionHeaderLayout>
  );
};

export default RewardSection;